import env from '@/config/env'
import request from '@/router/axios'

/**
 * 获取
 * @param lazy
 * @param parentId
 * @returns {*}
 */
export const getMenuTree = (lazy,parentId) => {
    return request({
        url: env.ferryUrl + '/menu/treeAll',
        method: 'GET',
        params: {
            lazy: lazy,
            parentId: parentId
        }
    })
}


/**
 * 保存菜单
 */
export const addMenu = (sysMenuInfo) => {
    return request({
        url: env.ferryUrl + '/menu',
        method: 'POST',
        data: sysMenuInfo
    })
}


/**
 * 获取菜单列表
 */
export const getMenuList = () => {
    return request({
        url: env.ferryUrl + '/menu/getMenuList',
        method: 'GET',
    })
}


/**
 * 编辑菜单
 */
export const editMenu = (sysMenuInfo) => {
    return request({
        url: env.ferryUrl + '/menu/update',
        method: 'PUT',
        data: sysMenuInfo
    })
}

/**
 * 删除菜单
 */
export const deleteMenu = (id) => {
    return request({
        url: env.ferryUrl + `/menu/delById/${id}`,
        method: 'DELETE'
    })
}


